export const history = [
  {
    path: '/history',
    name: 'History',
    component: () => import('./index.vue'),
    meta: {
      rule: 'INSPECTION_HISTORY',
      authRequired: true,
      title: 'general.history',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/'
        },
        {
          text: 'general.history',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/history-total',
    name: 'HistoryTotal',
    component: () => import('./total.vue'),
    meta: {
      rule: 'REPORT_COMPANIES',
      authRequired: true,
      title: 'general.historyTotal',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/'
        },
        {
          text: 'general.historyTotal',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/history/view/:id',
    name: 'viewHistory',
    component: () => import('../inspections/form.vue'),
    meta: {
      rule: 'INSPECTION_READ',
      authRequired: true,
      title: 'inspections.view',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/'
        },
        {
          text: 'general.history',
          disabled: false,
          href: '#/history'
        },
        {
          text: 'inspections.view',
          disabled: true
        }
      ]
    }
  }
]